import React from 'react';
import WizardModal from '../../Modules/Wizard/Componets/WizardModal';
import { WizardAction } from '../../Modules/Wizard/Interfaces/Wizard.interface';
import { CloseCaseButtonProps } from './CloseCaseButton';
import { resolveWizardAction } from '../../Modules/Wizard/Services/wizard.service';

interface Props extends CloseCaseButtonProps {
	onClose: () => void;
	resolveCall: () => void;
	onCaseClose: () => void;
}

const CloseCaseButtonDynamic: React.FC<Props> = ({
	resolveCall,
	onCaseClose,
	caseId,
	onClose,
}) => {
	const closeCase = (action?: WizardAction) => {
		resolveCall();
		resolveWizardAction(action);
		onCaseClose();
	};

	return (
		<WizardModal
			title='base.shared.closeCase'
			isOpen
			onClose={onClose}
			wizardKey='solve-case'
			onWizardDone={closeCase}
			initialData={{ caseId }}
			keepInitialData
			jobWaitingSetup={{ timeout: 180000 }}
		/>
	);
};

export default CloseCaseButtonDynamic;
